module.exports = __webpack_public_path__ + "media/images/icon__teaserSampleBetInfo@2x-9f8ed911f7189cb386934ad720662eec.png";